import { createRouter } from '@tanstack/react-router'
import { routeTree } from '@/routeTree.gen'
import { queryClient } from '@/app/query/query-client'
import { FullPageSpinner } from '@/components/common/FullPageSpinner'
import { ErrorState } from '@/components/feedback/ErrorState'

function RouteErrorFallback({ error }: { error: Error }) {
  return <ErrorState error={error} />
}

export const router = createRouter({
  routeTree,
  // Injected into every route's context (loaders & guards).
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingComponent: FullPageSpinner,
  defaultErrorComponent: RouteErrorFallback,
})

// Register the router instance for full type-safety across the app.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
